class TrainCarPack{
    constructor(id, trainCarCount, type, client, orderCode)
    {
        this.id = id;
        this.trainCarCount = trainCarCount;
        this.type = type;
        this.client = client;
        this.orderCode = orderCode;
        this.isPreparing = false;
    }
}
export default TrainCarPack;